import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import Preload from "image-preload";
Preload(["/edge/images/updated_logos/vacancy.svg"]);
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class CurrentVacancyDeveloper extends React.Component {
  static contextType = FilterContext;

  state = {
    areaActual: 0,
    areaPerc: 0,
    filters: "",
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_current_vacancy", BodyAsFormData(filters))
      .then((res) => {
        this.setState({
          areaActual: res.data.area_actual,
          areaPerc: res.data.area_perc,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_current_vacancy",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({
            areaActual: res.data.area_actual,
            areaPerc: res.data.area_perc,
          });
        });
    }
  }

  render() {
    return (
      // <div class="widget widgetDeveloperRight">
      //   <div class="row">
      //
      //     <div class="col-lg-12 flexCenter">
      //       <img
      //         src="/edge/images/updated_logos/vacancy.svg"
      //         alt="Current Vacancy Icon"
      //         className="imgWidth100"
      //       />
      //     </div>
      //     <div class="col-lg-12 text-center colorGreen">
      //       <h1>{this.state.areaActual}</h1>
      //       <p>({this.state.areaPerc} %)</p>
      //       {/* <h1>-</h1> */}
      //       <p class="widgetName">Current Vacancy</p>
      //     </div>
      //   </div>
      // </div>
      <div className="newWidgetClass position-relative">
        <div className="infoCircle text-end">
          <FontAwesomeIcon icon={faInfoCircle} style={{ color: "#cccccc" }} />
          <div className="vacancyInfo2" style={{ display: "none" }}>
            <p className="text-center">
              Vacancy is based on registered leases only
            </p>
          </div>
        </div>
        <img
          alt="Current Vacancy Icon"
          src="/edge/images/updated_logos/vacancy.svg"
          className="imgWidth100"
        />
        <div className="colorGreen">
          <h2>{this.state.areaActual} <span>({this.state.areaPerc} %)</span> </h2>
          <p>Current Vacancy</p>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(CurrentVacancyDeveloper);
